import { useMemo } from 'react';

import { useExtensionList } from '@confluence/forge-ui/entry-points/useExtensionList.ts';
// eslint-disable-next-line no-restricted-imports
import { GLOBAL_PAGE_FORGE } from '@confluence/named-routes/src/routes.ts';

import { getGlobalAppsParams } from './getGlobalAppsParams.ts';

type ExtensionWithUrl = ReturnType<typeof useExtensionList>['extensions'][number] & {
	url: string | undefined;
};

type UseExtensionsWithUrlsReturnType = Omit<ReturnType<typeof useExtensionList>, 'extensions'> & {
	extensions: ExtensionWithUrl[];
};

export const useExtensionsWithUrls: ({
	accessStatus,
	edition,
}: {
	accessStatus: any;
	edition: any;
}) => UseExtensionsWithUrlsReturnType = ({ accessStatus, edition }) => {
	const { forgeExtensionParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	const { extensions, loading, error } = useExtensionList(forgeExtensionParams);

	// Memoised so the derived array keeps a stable identity while `extensions` is unchanged. See the
	// sibling comment in `useWebItemsWithUrls` for why this matters (COPPER-1474).
	return useMemo(
		() => ({
			extensions:
				!extensions || error
					? []
					: extensions.map((extension) => ({
							...extension,
							url: GLOBAL_PAGE_FORGE.toUrl({
								appId: extension.appId,
								envId: extension.environmentId,
								forgeManifestRoute: extension.properties.route,
							}),
						})),
			loading,
			error,
		}),
		[extensions, loading, error],
	);
};
